import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
	selector: 'sh-maintenance',
	imports: [CommonModule, TranslocoModule],
	templateUrl: './maintenance.component.html',
	styleUrl: './maintenance.component.scss',
	standalone: true
})
export class MaintenanceComponent {
	public showRibbon = input<boolean>(true);
	public startAt = input<string>('');
	public endAt = input<string>('');
}
